import { useEffect, useState } from "react";

/**
 * Returns `false` on the server and during the first client render, flipping to `true` after
 * mount. Use it to gate client-only, viewport-dependent DOM branches (e.g. a mobile-vs-desktop
 * layout switch driven by `useBreakpoint`) so the first client render matches the SSR HTML and
 * hydration never mismatches — the branch swaps in a subsequent, post-hydration render instead.
 */
export function useHasMounted(): boolean {
  const [hasMounted, setHasMounted] = useState(false);
  useEffect(() => setHasMounted(true), []);
  return hasMounted;
}
